import ajax from "./request.js";

let bool = process.env.NODE_ENV === "production";
const href = bool
  ? `https://${window.location.host}/api/cloud/user`
  : "/api/cloud/user";

function phoneNumberWay(data) {
  return ajax(`${href}/smsLogin`, {
    method: "POST",
    data,
  });
}

function userPasswordLogin(data) {
  return ajax(`${href}/login`, {
    method: "POST",
    data,
  });
}

function registerUser(data) {
  return ajax(`${href}/register`, {
    method: "POST",
    data,
  });
}

function getLoginVerifyCode(data) {
  return ajax(`${href}/loginSms`, {
    method: "POST",
    data,
  });
}

function getUpdateVerifyCode(data) {
  return ajax(`${href}/updateSms`, {
    method: "POST",
    data,
  });
}

function getProfile() {
  return ajax(`${href}/profile`, {
    method: "GET",
  });
}

function updateProfile(data) {
  return ajax(`${href}/updateProfile`, {
    method: "POST",
    data,
  });
}

function changePassword(data) {
  return ajax(`${href}/changePassword`, {
    method: "POST",
    data,
  });
}

function bindWechat(data) {
  return ajax(`${href}/bindWechat`, {
    method: "POST",
    data,
  });
}

function unbindWechat(data) {
  return ajax(`${href}/unbindWechat`, {
    method: "POST",
    data,
  });
}

function changePhone(data) {
  return ajax(`${href}/changePhone`, {
    method: "POST",
    data,
  });
}

function getDashboard() {
  return ajax(`${href}/dashboard`, {
    method: "GET",
  });
}

function adminResetUserPassword(data) {
  return ajax(`${href}/admin_reset_password`, {
    method: "POST",
    data,
  });
}

export default {
  phoneNumberWay,
  userPasswordLogin,
  registerUser,
  getLoginVerifyCode,
  getUpdateVerifyCode,
  getProfile,
  updateProfile,
  changePassword,
  bindWechat,
  unbindWechat,
  changePhone,
  getDashboard,
  adminResetUserPassword,
};
